export default __webpack_public_path__ + "static/media/srinagar7.5708657f.jpg";